module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--fr-6e62f48c65705855365dba037d836fd6.jpg";